import { comparisonData } from '@/mocks/hoobuyData';

export default function ComparisonTable() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3.5 py-1.5 rounded-full border border-background-300 text-xs font-medium text-foreground-600 mb-4">
            Comparação
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Comparação das Plataformas
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Veja como o Hoobuy se compara com outras plataformas de compras internacionais
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200 bg-background-50">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200 bg-background-100">
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                  Plataforma
                </th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                  Facilidade
                </th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                  Preço
                </th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                  Entrega
                </th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                  Nota
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((item, index) => (
                <tr
                  key={index}
                  className={`border-b border-background-100 last:border-0 ${
                    item.destaque ? 'bg-primary-50/50' : ''
                  }`}
                >
                  <td className="px-5 py-3.5">
                    <span className={`font-semibold whitespace-nowrap ${item.destaque ? 'text-primary-700' : 'text-foreground-800'}`}>
                      {item.platform}
                      {item.destaque && (
                        <span className="ml-2 inline-block px-1.5 py-0.5 rounded bg-primary-500 text-[10px] font-bold text-background-50">
                          TOP
                        </span>
                      )}
                    </span>
                  </td>
                  <td className="text-center px-5 py-3.5">
                    <div className="flex items-center justify-center gap-1.5">
                      <span className={`font-semibold ${item.destaque ? 'text-primary-700' : 'text-foreground-700'}`}>
                        {item.facilidade}
                      </span>
                      <span className="text-[10px] text-foreground-400">/10</span>
                    </div>
                  </td>
                  <td className="text-center px-5 py-3.5">
                    <div className="flex items-center justify-center gap-1.5">
                      <span className={`font-semibold ${item.destaque ? 'text-primary-700' : 'text-foreground-700'}`}>
                        {item.preco}
                      </span>
                      <span className="text-[10px] text-foreground-400">/10</span>
                    </div>
                  </td>
                  <td className="text-center px-5 py-3.5">
                    <div className="flex items-center justify-center gap-1.5">
                      <span className={`font-semibold ${item.destaque ? 'text-primary-700' : 'text-foreground-700'}`}>
                        {item.entrega}
                      </span>
                      <span className="text-[10px] text-foreground-400">/10</span>
                    </div>
                  </td>
                  <td className="text-center px-5 py-3.5">
                    <span className={`inline-flex items-center justify-center w-12 h-7 rounded-full text-xs font-bold ${
                      item.destaque
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                    }`}>
                      {item.nota}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}